// extracted by mini-css-extract-plugin
export default {"img":"back_image_img__4L-RI","overlay":"back_image_overlay__55q5F"};